import React from "react";
import CartContent from "./cartContent";
import { Footer, Header } from "../../layouts";
import {
  decreaseQuantity,
  increaseQuantity,
  removeFromCart,
} from "../../store/cart.slice";
import { useDispatch, useSelector } from "react-redux";
import { HeroSm } from "..";
import { Slang } from "../../helpers";

const Index = () => {

  const cart = useSelector((state) => state.cart.cart);

  const getTotal = () => {
    // let totalQuantity = 0;
    let totalPrice = 0;

    cart.forEach((item) => {
      const price = parseFloat(item.price);  //(item.price.split("$")[1]);
      // console.log("price", price);

      // totalQuantity += item.quantity;
      totalPrice += price * item.quantity;
    });

    // console.log(totalPrice);

    return { totalPrice }; //, totalQuantity };
  };

  const lang = Slang("navbar");


  return (
    <>
      <Header />
      {/* <HeroSm sub title={}/> */}
      <HeroSm sub title={lang("t10")}/>
      <div className=" container ">
        <CartContent
          items={cart}
          IncreaseQuantity={increaseQuantity}
          DecreaseQuantity={decreaseQuantity}
          RemoveFromCart={removeFromCart}
          GetTotal={getTotal()}
        />
      </div>
      <Footer />
    </>
  );
};

export default Index;
